/*================ API Factory===================*/
 angular
 .module('vppApp')
 .factory('apiFactory', apiFactory);

apiFactory.$inject = ['$http', '$log', 'vppConfig'];

function apiFactory($http, $log, vppConfig) {
 var domainName = vppConfig.domainName;
 var apiPath = vppConfig.APIPath;
 var apiSite = vppConfig.folderPath;
 //REGION API PATH - https://wiki.mrmanywhere.com/display/VPPREDESIGN/Local+Testing
 var sharedPath = domainPath + "/vpprs";
 var apiFactory = {};
 $log.info(apiPath);

 // SIGN-IN
 //Attempts to log in the user.
 apiFactory.signIn = function(accountInfo){
   return $http.post(apiPath + "/login/" + apiSite, accountInfo);
 };

 // SIGN-OUT
 //Attempts to log out the user.
 apiFactory.signOut = function() {
   return $http.get(apiPath + "/login/logout?site=" + apiSite);
 };

 // COMPANY SEARCH
 apiFactory.company = function(companyName) {
   // return $http.get("/content/json/testing/company.data.json");
   return $http.get(apiPath + "/company/search/" + apiSite + "/" + companyName);
 };

 // FORGOT PASSWORD
 // Resets the password and sends the email on the login email-id
 apiFactory.forgotPasswordReset = function(newPasswordData) {
   return $http.post(apiPath + "/forgot/password/reset/" + apiSite, newPasswordData);
 };

 // Validate the passed username for the entered site or portfolio.
 apiFactory.forgotPasswordValidate = function(userName) {
   return $http.get(apiPath + "/forgot/password/" + apiSite + "/" + userName);
 };

 // ELIGIBLE VEHICLES

 //Get vehicles pricing
 apiFactory.vehiclesPricing = function() {
   return $http.get(sharedPath + "/shared/showroom/pricing-summary.json");
 };
 //Get vehicles model
 apiFactory.vehiclesModel = function() {
   return $http.get(sharedPath + "/shared/showroom/model-summary.json");
 };

 // MASTHEAD SLIDER
 //Retrieve slider information to populate
 apiFactory.mastheadSliderOptions = function(options) {
   var vehicles = {
     styles: [],
     siteCode: vppConfig.folderPath
   };

   for (var i = 0; i < options.length; i++) {

     var temp = {
       "styleID": options[i].styleID,
       "serializedValue": options[i].serializedValue
     };
     vehicles.styles.push(temp);
   }
   return $http.post(apiPath + "/masthead/iom", vehicles);
 };

 // CURRENT OFFERS
 apiFactory.zipCodeToRegion = function(zipCode) {
   return $http.get(apiPath + "/region/" + apiSite + "/" + zipCode);
 };

 apiFactory.getCurrentOffers = function(jsonPath) {
   //REGION JSON PATH
   return $http.get(sharedPath + jsonPath);

 };

 // RESET PASSWORD REQUEST:
 apiFactory.resetPasswordRequest = function(body) {
   return $http.post(apiPath + "/ResetPasswordRequest/" + apiSite, body);
 };

 // RESET PASSWORD CONFIRM:
 apiFactory.resetPasswordConfirm = function(body) {
   return $http.post(apiPath + "/ResetPasswordConfirm/" + apiSite, body);
 };

 // CHANGE PASSWORD:
 apiFactory.changePassword = function(body) {
   return $http.post(apiPath + "/changePassword/" + apiSite, body);
 };

 // EDIT PROFILE:
 apiFactory.getProfileDetails = function(accountID) {
   return $http.get(apiPath + "/profile/details/" + accountID);
 };

 // CHANGE USERNAME REQUEST:
 apiFactory.changeUsernameRequest = function(accountID, accountInfo) {
   return $http.post(apiPath + "/profile/changeUsername/" + accountID, accountInfo);
 };
 // CHANGE USERNAME CONFIRM:
 apiFactory.changeUsernameConfirm = function(body) {
   return $http.post(apiPath + "/profile/confirmChangeUsername/" + apiSite, body);
 };

 // SAVE PROFILE:
 apiFactory.setProfileDetails = function(accountID, accountInfo) {
   return $http.post(apiPath + "/profile/demographic/" + accountID, accountInfo);
 };
 // Save Modified Modules user information
 apiFactory.setModifiedProfileDetails = function(accountID, accountInfo) {
   return $http.post(apiPath + "/profile/moduleInfo/" + accountID, accountInfo);
 };

  // PROFILE OnStar lock status:
  apiFactory.getOnStarLockStatus = function(username) {
    return $http.get(apiPath + "/profile/onStarLock/" + username);
  };

 // Get Customer
 apiFactory.getCustomer = function(accountID) {
   return $http.get(apiPath + "/customer/" + accountID);
 };

 // CONTACT FORM
 //Sends contact fields to the server..
 apiFactory.contactForm = function(fieldInfo) {
   return $http.post(apiPath + "/contact-us/" + apiSite, fieldInfo);
 };

 // FIND A DEALER FORM
 //Sends fields to the server..
 apiFactory.findDealerForm = function(options) {
   return $http.get(apiPath + "/dealer/" + options);
 };

 apiFactory.setLoginDetails = function(accountId, accountInfo) {
   return $http.post(apiPath + "/profile/security/" + accountId, accountInfo);
 };

 apiFactory.getSecurityQuestions = function() {
   return $http.get(apiPath + "/data/security-questions/" + apiSite);
 };
 // Registration - USER
 apiFactory.userRegistration = function(userRegistrationInfo, siteCode) {
  if(siteCode){
   return $http.post(apiPath + "/register/" + siteCode, userRegistrationInfo);
  } else {
   return $http.post(apiPath + "/register/" + apiSite, userRegistrationInfo);
  }
 };
 // Registration - USERName Validation
 apiFactory.userRegistrationValidation = function(userRegistrationValidation, siteCode) {
  if(siteCode){
    return $http.post(apiPath + "/register/validate/" + siteCode, userRegistrationValidation);
  } else {
    return $http.post(apiPath + "/register/validate/" + apiSite, userRegistrationValidation);
  }
 };

   // Registration - Populate Fields
   apiFactory.readRegistrationCookie = function() {
     return $http.get(apiPath + "/profile-details/");
   };

 /* updates user address by accuntID */
 /* requires address object */
 apiFactory.updateUserAddress = function(accountID, addressInformation) {
   return $http.post(apiPath + "/legacy/customer-update/" + accountID, addressInformation);
 };

 /* Audit Code post dataObj == { "auditAction": "login|addresscurrent-yes|addresscurrent-no|editinterval-toosoon|editsuccessful|editcancelled" } */
 apiFactory.auditAction = function(accountID, auditAction) {
   return $http.post(apiPath + "/legacy/audit/" + accountID, auditAction);
 };

 apiFactory.userRegistrationDetails = function() {
   return $http.get(apiPath + "/register/details/" + apiSite);
 };

 // Registration Modules get /module/user/{site}/{modulename}/{moduleaction}
 apiFactory.userRegistrationUserModule = function(moduleName, moduleAction) {
   return $http.get(apiPath + "/module/user/" + apiSite + "/" + moduleName + "/" + moduleAction);
 };
 apiFactory.vehicleInformation = function(leadsVOIValue, programID) {
   return $http.post(apiPath + "/module/auth/" + apiSite + "/tpl/getVehicleInfoMap", {
     moduleActionDetails: {
       LeadsVOIEligibility: leadsVOIValue,
       programID: programID
     }
   });
 };


 /*===== Authorization API Calls ==========*/
 // Auth History
 apiFactory.authHistory = function(accountID, thisId, pageNumber) {
   return $http.get(apiPath + "/authorization/history/" + accountID + "/" + thisId + "/?pageNumber=" + pageNumber);
 };
 // Auth program(s)
 apiFactory.authProgram = function(accountID, programID) {
   return $http.get(apiPath + "/authorization/program/" + accountID + "/" + programID);
 };
 // Authorization
 apiFactory.authorization = function(accountID, AuthRequest) {
   return $http.post(apiPath + "/authorization/" + accountID, AuthRequest);
 };
 // Auth Void
 apiFactory.authVoid = function(accountID, authorizationCode) {
   return $http.post(apiPath + "/authorization/void/" + accountID + "/" + authorizationCode);
 };
 // Auth Email
 apiFactory.authEmail = function(accountID, authorizationCode, emailInfo) {
   return $http.post(apiPath + "/authorization/email/" + accountID + "/" + authorizationCode + "/", emailInfo);
 };
 // Auth Edit
 apiFactory.authEdit = function(accountID, authCode, editInfo) {
   return $http.post(apiPath + "/authorization/edit/" + accountID + "/" + authCode, editInfo);
 };
 // Authorization Modules get /module/auth/{site}/{modulename}/{moduleaction}
 apiFactory.authModuleGet = function(moduleName, moduleAction) {
   return $http.get(apiPath + "/module/auth/" + apiSite + "/" + moduleName + "/" + moduleAction);
 };
 // Authoriztion Module Post /module/auth/{site}/{modulename}/{moduleaction}
 apiFactory.authModulePost = function(moduleName, moduleAction, moduleActionDetails) {
   return $http.post(apiPath + "/module/auth/" + apiSite + "/" + moduleName + "/" + moduleAction, {
     moduleActionDetails: moduleActionDetails
   });
 };

 /*===== Vehicle Tagging API Calls ==========*/
 // VT Send Email
 apiFactory.vtSendEmail = function(accountID, tagID, options) {
   return $http.post(apiPath + "/tagging/email/" + accountID + "/" + tagID, options);
 };
 // VT vehicle filters changes request
 apiFactory.vtFilter = function(accountID, programID, options) {
   return $http.get(apiPath + "/tagging/filters/" + accountID + "/" + programID + options);
 };
 // VT vehicle history
 apiFactory.vtHistory = function(accountID, programID) {
   return $http.get(apiPath + "/tagging/history/" + accountID + "/" + programID);
 };
 // VT vehicle init request
 apiFactory.vtInit = function(accountID, programID) {
   return $http.get(apiPath + "/tagging/init/" + accountID + "/" + programID);
 };
 // VT find vehicles
 apiFactory.vtSearch = function(accountID, programID, options) {
   return $http.get(apiPath + "/tagging/search/" + accountID + "/" + programID + options);
 };
 // VT vehicle detail
 apiFactory.vtDetail = function(accountID, programID, vin) {
   return $http.get(apiPath + "/tagging/vehicle-detail/" + accountID + "/" + programID + "/" + vin);
 };
 // VT emission code
 apiFactory.vtEmission = function(accountID, programID) {
   return $http.get(apiPath + "/tagging/vehicle-summary/" + accountID + "/" + programID);
 };
 // VT vehicle summary
 apiFactory.vtSummary = function(accountID, programID, emissionCode) {
   return $http.get(apiPath + "/tagging/vehicle-summary/" + accountID + "/" + programID + "/" + emissionCode);
 };
 // VT tagging void
 apiFactory.vtTagVoid = function(accountID, programID, tagID) {
   return $http.post(apiPath + "/tagging/void/" + accountID + "/" + programID + "/" + tagID);
 };
 // VT tagging
 apiFactory.vtTag = function(accountID, programID, taggingInfo) {
   return $http.post(apiPath + "/tagging/" + accountID + "/" + programID, taggingInfo);
 };

 // ID me
 apiFactory.idMeAccessUserData = function() {
   return $http.post(apiPath + "/idme/userData/" + apiSite);
 };

 apiFactory.idMeVerifyUser = function(accountID) {
  return $http.get(apiPath + "/idme/verify/" + accountID + "/" + apiSite);
};

 apiFactory.gcVerify = function(){
   return $http.get(apiPath + "/samljunction/samlsso?app=" + apiSite);
 }

 apiFactory.getSsoUrl = function(authCheck = "", siteCode) {
   if(siteCode){
    return $http.get(apiPath + "/getssourl?siteCode=" + siteCode + "&authCheck=" + authCheck);
   } else {
    return $http.get(apiPath + "/getssourl?siteCode=" + apiSite + "&authCheck=" + authCheck);
   }
 };

 apiFactory.verifyEmail = function(token){
   return $http.get(apiPath + "/verifyemail?site=" + apiSite + "&verificationCode=" + token);
 }

 apiFactory.mobileLoginApi = function(body){
   return $http.post(apiPath + "/mobileLogin/",  body);
 }

 // Legacy Eligibility
 // Registration - USER
 apiFactory.legacyEligibility = function(formData) {
   console.log(apiPath + "/flpregister/" + apiSite);
   return $http.post(apiPath + "/flpregister/" + apiSite, formData);
 };

 apiFactory.nonGMDealershipEmployeeAuthorization = function(formData) {
     console.log(apiPath + "/nonGMDealerEmployeeauthorization/");
     return $http.post(apiPath + "/nonGMDealerEmployeeauthorization/", formData);
 };
 apiFactory.postDetermineRegistrationRoute = function(body) {
  return $http.post(apiPath + '/registrationRoute/', body);
 };

 apiFactory.postMigratedUserRegistration = function(body) {
   return $http.post(apiPath + "/migratedUserRegistration/", body);
 };

 apiFactory.postResendVerificationEmail = function( email, siteCode) {
   return $http.post(apiPath + '/verificationEmail' + '?siteCode=' + siteCode + '&email=' + email);
 }

 apiFactory.getVerificationEmail = function() {
  return $http.get(apiPath + '/getEmail');
}

apiFactory.getForgotPasswordURL=function(siteCode, lang){

  return $http.get(apiPath + '/getforgotpasswordurl' + '?siteCode=' + siteCode + '&lang=' + lang)
}

 // END OF API FACTORY
 return apiFactory;
}
